import { Navigate } from 'react-router-dom';
import React from 'react';

import { AppRoutePath } from '../AppRoutePath';

export const ReplaceToHome: React.FC = () => {
  return <Navigate to={AppRoutePath.Home} replace />;
};
